import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(({ color }) => ({
  root: {
    fontFamily: 'Dazzed',
    fontWeight: 500,
    fontSize: 11,
    lineHeight: '18px',
    color: ({ color }) => color ?? 'var(--text-color-6)'
  },
  bold: {
    fontWeight: '600 !important'
  },
  thin: {
    fontWeight: '400 !important'
  }
}))

const DazzedParagraph11 = ({ children, className, color, thickness = 'normal', onClick, id, textAlign = 'left' }) => {
  const classes = useStyles({ color })

  return (
    <div
      style={textAlign ? { textAlign } : {}}
      className={[
        classes.root,
        thickness === 'bold' && classes.bold,
        thickness === 'thin' && classes.thin,
        className
      ].join(' ')}
      onClick={onClick}
      id={id}
    >
      {children}
    </div>
  )
}

export default DazzedParagraph11
